export const getIbanType = (type: string) => {
    switch (type) {
        case 'prefund':
            return 'Pre-fund';
        case 'settlement':
            return 'Settlement';
        default:
            return '';
    }
};
